





















import {Component, Mixins, Prop, Watch} from "vue-property-decorator";
import {Getter} from "vuex-class";
import _ from "lodash";
import SelectSearch from "@/components/forms/search/SelectSearch.vue";
import Owner from "@/model/cospirit-api/Owner";
import CommonSelectOwnerMixin from "@/mixins/components/CommonSelectOwnerMixin";
import CsTreeSelect from "@/components/miscellaneous/CsTreeSelect.vue";

const components = {
    SelectSearch,
    CsTreeSelect,
};

@Component({ components })
export default class SelectOwner extends Mixins(CommonSelectOwnerMixin) {
    @Prop({type: String, default: null}) private value!: string | null;
    @Prop(Boolean) private disable!: boolean;
    @Prop(String) private fromOwnerUuid!: string;
    @Prop(String) private placeholder!: string;
    @Prop(Boolean) private clearable!: boolean;
    @Prop({type: Boolean, default: true}) private filteredByRights!: boolean;
    @Prop(Array) private showParentsAmongUuids!: string[];
    @Prop({type: Boolean, default: false}) private showOnlyValue!: boolean;

    @Getter("getCurrentOwnerUuid") public currentOwnerUuid!: string;

    private selectedOwnerUuid: string | null = null;

    @Watch("value") private updateValue() {
        this.selectedOwnerUuid = this.value;
    }

    @Watch("ownerList") private onOwnerListChange() {
        this.setAvailableOwners();
    }

    @Watch("masterOwners") private onMasterOwnersChange() {
        this.setAvailableOwners();
    }

    @Watch("fromOwnerUuid") private refreshOwners() {
        this.setAvailableOwners();
        if ( this.selectedOwnerUuid &&
            !this.inNodes(this.selectedOwnerUuid, this.treeOptions)
            && this.treeOptions.length > 0
        ) {
            this.updateSelectedOwner(null);
        }
    }

    private updateSelectedOwner(selectedOwnerUuid: string | null): void {
        this.selectedOwnerUuid = selectedOwnerUuid;
        this.$emit("input", this.selectedOwnerUuid);
    }

    private mounted(): void {
        this.selectedOwnerUuid = this.value;
        if (!this.selectedOwnerUuid && 1 === this.masterOwners.length) {
            const firstOwner = _.first(this.masterOwners);
            if (firstOwner) {
                this.updateSelectedOwner(firstOwner.uuid);
            }
        }
        this.setAvailableOwners();
    }

    private setAvailableOwners() {
        this.filteredOwners = this.filterOwners(_.clone(this.masterOwners));
        if (this.ownerList) {
            this.availableOwners = this.ownerList;
            return;
        }
        // we build options from children instead of parents,
        // this allows to only show options that have result in the database (ownerList prop)
        const availableOwnerList = this.isAncestorsSearch() ? this.filteredOwners : Object.values(this.children);
        this.availableOwners = availableOwnerList.map((owner) => {
            return {
                uuid: owner.uuid,
                fullName: _.get(owner, "fullName", ""),
            };
        });

        if (1 === this.availableOwners.length) {
            // Si la liste ne contient plus qu'une option après filtrage,
            // il faut forcer la mise à jour avec la seule option.
            const firstOption = _.first(this.availableOwners);
            if (firstOption) {
                this.updateSelectedOwner(firstOption.uuid);
            }
        }
        this.$emit("number-options-changed", this.availableOwners.length);
    }

    private isAncestorsSearch(): boolean {
        return _.isArray(this.showParentsAmongUuids) && !_.isEmpty(this.showParentsAmongUuids);
    }

    private filterOwners(owners: Owner[]): Owner[] {
        const filteredOwners = this.filterOwnersBy(owners);

        if (this.isAncestorsSearch()) {
            return this.searchParentsAmong(filteredOwners, this.showParentsAmongUuids);
        }

        return filteredOwners.sort((a: Owner, b: Owner) => {
            if (!a.left || !b.left) {
                return 0;
            }
            return a.left - b.left;
        });
    }

    private filterOwnersBy(owners: Owner[]): Owner[] {
        const fromOwner = owners.find((owner: Owner) => {
            return owner.uuid === this.fromOwnerUuid;
        });

        const leftFromOwner = fromOwner?.left || -1;
        const rightFromOwner = fromOwner?.right || -1;
        return owners.filter(
            (owner: Owner) => {
                this.addChildrenAndParents(owner);
                const filterByOwnerUuid = this.fromOwnerUuid ?
                    (owner.left ? owner.left : 0) >= leftFromOwner &&
                    (owner.right ? owner.right : 0) <= rightFromOwner :
                    true;
                const filterByDepthRights = this.filteredByRights ?
                    !_.has(owner, "hasRights") || 1 === _.get(owner, "hasRights", false) :
                    true;
                return filterByOwnerUuid && filterByDepthRights;
            }
        );
    }

    private searchParentsAmong(owners: Owner[], showNearestParentAmongUuids: string[]) {
        const result: Owner[] = [];
        showNearestParentAmongUuids.forEach((uuid: string) => {
            const possibleAncestor = owners.find((o: Owner) => o.uuid === uuid);
            if (!possibleAncestor) {
                return;
            }
            const mustBeShow = owners.some((owner: Owner) => {
                return _.has(owner, "left")
                    && _.has(owner, "right")
                    && _.has(possibleAncestor, "left")
                    && _.has(possibleAncestor, "right")
                    && _.get(owner, "left", 0) >= _.get(possibleAncestor, "left", 0)
                    && _.get(owner, "right", 0) <= _.get(possibleAncestor, "right", 0);
            });
            if (mustBeShow) {
                result.push(possibleAncestor);
            }
        });

        return result;
    }
}
